export const NewsRoute: Path = '/news'

export const SolitaireHorizontalMoveRoute: Path = `${NewsRoute}/solitaire-horizontal-move`

export const SolitaireMovesCardsRoute: Path = `${NewsRoute}/solitaire-moves-cards`

export const SolitaireTermsExplainedRoute: Path = `${NewsRoute}/solitaire-terms-explained`

export const SolitaireUndoTrickRoute: Path = `${NewsRoute}/solitaire-undo-trick`

export const ThisSimpleSolitaireGaveMeMoreRoute: Path = `${NewsRoute}/this-simple-solitaire-gave-me-more`

export const SolitaireClashMomsWeekWithLoveRoute: Path = `${NewsRoute}/solitaire-clash-moms-week-with-love`
export const AviaPetAdoptionTangtangRoute: Path = `${NewsRoute}/avia-pet-adoption-tangtang`
export const AviaAnimalRescueJiabaoRoute: Path = `${NewsRoute}/avia-animal-rescue-jiabao`
